import { useHandlers } from '../../../context/page-context';
import type { PricingApiContract } from '../api';

export function usePricingApi(): { pricingApi: PricingApiContract } {
  const { apis } = useHandlers();
  return { pricingApi: apis.pricing };
}
